module.exports = __webpack_public_path__ + "static/media/golfer-6-a.77f4adfc.png";